import * as enUS from './en-us';
import * as ptBr from './pt-br';

const translations = [enUS, ptBr];

export const getTranslation = (language) => {
  try {
    const resource = translations.filter(
      (res) => res.default.lang === language,
    )[0].default.text;
    if (!resource) throw new Error('Invalid translation resource');
    return resource;
  } catch (error) {
    console.error('getTranslation', error);
  }
  return null;
};

// export const getTranslation = async (language) => {
//   try {
//     const resource = await import(`./${language}.js`);
//     console.log(resource?.default?.text);
//     return resource?.default?.text;
//   } catch (error) {
//     console.error('getTranslation', error);
//   }
// };

export default getTranslation;
